import React from 'react';
import Header from './Header';
import Menu from './menu/Menu';
import Content from './Content';

import HasPageState from './mixin/HasPageState';
import HasMenu from './mixin/HasMenu';

import * as Cookies from 'js-cookie';
import axios from 'axios';

axios.defaults.headers.post = {
    "X-CSRFToken": Cookies.get('csrftoken')
};

axios.defaults.headers.put = {
    "X-CSRFToken": Cookies.get('csrftoken')
};

axios.defaults.headers.delete = {
    "X-CSRFToken": Cookies.get('csrftoken')
};

/**
 * Dairy One Single page application.
 * @author James Adams
 */
class DairyOneSpa extends React.Component{
  /**
   * 1. Construct the DairyOneSpa.
   * 2. Gather pages.
   * 4. Gather states.
   * 5. Setup mixins.
   * @param {object} props
   */
  constructor(props){
    super(props);
    this.chidrenNodes = props.children;
    this.state={};

    this.pages = this._collectValues(props.pages, 'component');
    const states = this._collectValues(props.pages, 'state');

    this.acl = props.acl;

    //mixin
    HasPageState.call(this);
    HasMenu.call(this, props.title, props.page, props.menuData);

    Object.keys(states).every(state=>{
      states[state].call(this, state);
      return true;
    });

    document.title = this.state.pageTitle;
  }


  /**
   * Reduce a complex object to key,values of the reference.
   * @param {object} obj
   * @param {string} ref key
   * @private
   * @returns {array}
   */
  _collectValues(obj, ref){
    return Object.keys(obj).reduce((hash,key)=>{
      if(obj[key][ref]){
        hash[key] = obj[key][ref];
      }
      return hash;
    },{});
  }


  /**
   * If present force a hash change.
   * @public
   */
  componentDidMount() {
    if(window.location.hash){
      this.hashChange();
    }
  }


  /**
   * Render the spa.
   * @returns {jsx}
   * @public
   */
  render(){
    return(
      <React.Fragment>
        {this.chidrenNodes}
        <Header
          clickHandler={this.handleToggleMenu.bind(this)}
          title={this.state.pageTitle}
          selectedMenu={this.state.selectedMenu}

        >
          <Menu
            menuData={this.menuData}
            menuToggle={this.state.menuToggle}
            selectedMenu={this.state.page}
            selectedSubMenu={this.state.selectedSubMenu}
            clickMenuItem={this.handleClickMenuItem.bind(this)}
            closeMenu={this.handleToggleMenu.bind(this)}
            acl={this.acl}
          />
        </Header>

        <Content
          page={this.state.page}
          item={this.state.item}
          pages={this.pages}
          state={this.state.pageState}
          getState={this.getPageState.bind(this)}
          updateState={this.updatePageState.bind(this)}
          resetState={this.resetPageState.bind(this)}
          resetMultipleState={this.resetMultiplePageState.bind(this)}
          acl={this.acl}
        />
      </React.Fragment>
    );
  }
}

export default DairyOneSpa;
